import useDocumentTitle from "hooks/useDocumentTitle";
import { useForm, FormProvider } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import { AllowDuplicateCptCodes } from "./components/AllowDuplicateCptCodes";
import { ContractLanguageField } from "./components/ContractLanguageField";
import { CptCodes } from "./components/CptCodes";
import { DiscountPercents } from "./components/DiscountPercents";
import { Header } from "./components/Header";
import { ProviderAndPayerSection } from "./components/ProviderAndPayerSection";
import { RuleName } from "./components/RuleName";
import { Submit } from "./components/Submit";

export function CreatePayerRulesPage() {
  useDocumentTitle("Create Payer Rules");
  const [searchParams] = useSearchParams();
  const asDefault = searchParams.get("asDefault") === "true";

  const methods = useForm({
    defaultValues: {
      provider: [],
      payerName: "",
      groupName: "",
      cptCodes: [],
      discountPercentForRank2: null,
      discountPercentForRank3: null,
      discountPercentForRank4: null,
      discountPercentForRank5Plus: null,
      allowOnDuplicateCptCodes: false,
      isDefault: asDefault,
      contractLanguage: "",
    },
  });
  return (
    <FormProvider {...methods}>
      <Header />
      <ProviderAndPayerSection />
      <RuleName />
      <AllowDuplicateCptCodes />
      <CptCodes />
      <DiscountPercents />
      <ContractLanguageField ruleType="MPPR" />
      <Submit />
    </FormProvider>
  );
}
